/* "Buy now" button on the product page (snippets/buy-buttons.liquid).
   Puts the selected variant in the cart (only if it isn't there yet), then goes straight to checkout.
   Anything already in the cart stays and is shown in checkout too. */
(function () {
  if (window.chitsBuyNowReady) return;
  window.chitsBuyNowReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Buy now is disabled whenever Add to cart is (sold out / unavailable variant)
  function watch(btn) {
    if (btn._chitsWatched) return;
    btn._chitsWatched = true;
    var submit = document.getElementById(btn.dataset.submit);
    if (!submit) return;
    var sync = function () {
      btn.disabled = submit.disabled;
    };
    sync();
    new MutationObserver(sync).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }

  function init() {
    document.querySelectorAll('[data-buy-now]').forEach(watch);
  }

  // go to checkout the same way the cart page does, so the store language is kept
  function goToCheckout() {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = root + 'cart';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'checkout';
    input.value = '1';
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  function reset(btn) {
    btn.classList.remove('is-loading');
    var label = btn.querySelector('[data-buy-now-label]');
    if (label) label.textContent = btn.dataset.label;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-buy-now]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    var form = document.getElementById(btn.dataset.form);
    var variantInput = form && form.querySelector('input[name="id"]');
    var submit = document.getElementById(btn.dataset.submit);
    if (!variantInput || !variantInput.value || variantInput.disabled || (submit && submit.disabled)) return;

    var variantId = Number(variantInput.value);
    var label = btn.querySelector('[data-buy-now-label]');
    btn.classList.add('is-loading');
    if (label) label.textContent = btn.dataset.loading;

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (item) {
          return item.variant_id === variantId;
        });
        if (inCart) return;
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        }).then(function (res) {
          if (res.ok) return;
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || btn.dataset.label);
          });
        });
      })
      .then(goToCheckout)
      .catch(function (error) {
        btn.classList.remove('is-loading');
        if (label) label.textContent = error.message || btn.dataset.label;
        setTimeout(function () {
          reset(btn);
        }, 3000);
      });
  });

  // coming back from checkout with the browser's Back button: show the normal button again
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-buy-now].is-loading').forEach(reset);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // variant changes / quick add can add new buttons later
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();